import { useMemo, useState } from 'react';
import { Button } from '@heroui/react';
import { ITeacherAssignmentsIntake } from '@/entities/TeacherAssignment';
import { Section } from '@/shared/ui/Section';
import { TeacherIntakeAssignmentsCard } from '../TeacherIntakeAssignmentsCard';

interface TeacherAssignmentsTestsProps {
  items?: ITeacherAssignmentsIntake[];
}

export const TeacherAssignmentsTests = ({ items = [] }: TeacherAssignmentsTestsProps) => {
  const [showAll, setShowAll] = useState(false);

  const visibleItems = useMemo(() => (showAll ? items : items.slice(0, 6)), [items, showAll]);

  return (
    <Section typeSection="section">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-2xl font-medium">Assignments / Tests</h3>
        {items.length > 6 && (
          <Button
            variant="bordered"
            onPress={() => setShowAll(!showAll)}
            className="border-neutral-border"
          >
            {showAll ? 'Hide all' : 'See all'}
          </Button>
        )}
      </div>

      {visibleItems.length > 0 ? (
        <div className="grid grid-cols-3 gap-4">
          {visibleItems.map((intake) => (
            <TeacherIntakeAssignmentsCard key={intake.id} intake={intake} />
          ))}
        </div>
      ) : (
        <div className="flex items-center justify-center py-12">
          <p className="text-neutral-500">No assignments to review at the moment</p>
        </div>
      )}
    </Section>
  );
};
